import RealAutoCompleteField from './RealAutoCompleteField';

export default RealAutoCompleteField;
